// extracted by mini-css-extract-plugin
export default {"chart_wrapper":"Charts_chart_wrapper__P9xhr","spinner":"Charts_spinner__ojzDt"};